var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedeem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_123_12",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.00049H22V21.1665H2V3.00049Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_123_12)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14.9795V17.0245C3.5 17.7305 3.774 18.3935 4.273 18.8925C4.772 19.3915 5.436 19.6665 6.141 19.6665H17.857C19.313 19.6665 20.499 18.4825 20.5 17.0265V14.9785C19.214 14.6455 18.261 13.4745 18.26 12.0855C18.26 10.6965 19.213 9.52549 20.499 9.19149L20.5 7.14649C20.501 5.68849 19.318 4.50149 17.861 4.50049H6.144C4.687 4.50049 3.501 5.68549 3.5 7.14249V9.25949C3.986 9.37549 4.437 9.61449 4.812 9.96449C5.381 10.4955 5.709 11.2155 5.737 11.9935C5.74 13.4595 4.787 14.6435 3.5 14.9795M17.857 21.1665H6.142C5.035 21.1665 3.995 20.7365 3.212 19.9535C2.43 19.1705 2 18.1305 2 17.0245V14.3245C2 13.9105 2.336 13.5745 2.75 13.5745C3.574 13.5735 4.24 12.9055 4.239 12.0855C4.225 11.6675 4.065 11.3195 3.789 11.0615C3.514 10.8035 3.158 10.6625 2.776 10.6835C2.569 10.6855 2.375 10.6145 2.229 10.4735C2.083 10.3325 2 10.1365 2 9.93349V7.14349C2.001 4.85849 3.86 3.00049 6.144 3.00049H17.856C20.146 3.00149 22.002 4.86349 22 7.14749V9.84649C22 10.2605 21.664 10.5965 21.25 10.5965C20.429 10.5965 19.76 11.2645 19.76 12.0845C19.761 12.9065 20.429 13.5745 21.25 13.5745C21.664 13.5745 22 13.9105 22 14.3245V17.0245C21.999 19.3085 20.14 21.1665 17.857 21.1665",
    fill: "#737791"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1038 11.3815L10.6128 11.8775C10.8888 12.1485 11.0138 12.5345 10.9478 12.9115L10.8278 13.6095L11.4568 13.2785C11.7958 13.0975 12.2028 13.0985 12.5448 13.2805L13.1698 13.6085L13.0498 12.9095C12.9868 12.5265 13.1128 12.1435 13.3858 11.8775L13.8948 11.3815L13.1898 11.2795C12.8118 11.2245 12.4838 10.9865 12.3148 10.6415L11.9998 10.0045L11.6848 10.6425C11.5158 10.9865 11.1878 11.2245 10.8078 11.2795L10.1038 11.3815ZM13.6178 15.3875C13.4318 15.3875 13.2458 15.3425 13.0738 15.2515L11.9998 14.6885L10.9248 15.2525C10.5288 15.4595 10.0578 15.4265 9.69783 15.1645C9.33683 14.9015 9.15983 14.4655 9.23483 14.0255L9.43983 12.8295L8.57083 11.9825C8.25183 11.6715 8.13783 11.2145 8.27483 10.7905C8.41283 10.3655 8.77283 10.0605 9.21383 9.99652L10.4178 9.82052L10.9548 8.73152C11.1518 8.33152 11.5518 8.08252 11.9998 8.08252C12.4458 8.08252 12.8468 8.33152 13.0438 8.73252L13.5818 9.82052L14.7838 9.99652C15.2258 10.0605 15.5868 10.3655 15.7238 10.7905C15.8608 11.2145 15.7478 11.6715 15.4278 11.9835L14.5578 12.8305L14.7638 14.0255C14.8388 14.4665 14.6608 14.9035 14.2988 15.1655C14.0948 15.3125 13.8568 15.3875 13.6178 15.3875V15.3875Z",
    fill: "#737791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/redeem.75421b3ef5e65e0e745c9b7ea5864061.svg";
export { ForwardRef as ReactComponent };